import React, { Component } from 'react';
import ReactDOM from 'react-dom';
import PropTypes from 'prop-types';
import shallowequal from "shallowequal";
import { Modal } from 'antd';
import CouponExplain from './CouponExplain'
const fontSize = 16;
const padding = 35;
const lineW = 16;
export default class Tabs extends Component {
  widthArr = [];
  translateArr = [];
  state = {
    explainModel: false
  }
  static propTypes = {
    defaultActiveKey: PropTypes.number,
    tabs: PropTypes.array.isRequired,
  };
  componentDidMount() {
    const { tabs, defaultActiveKey } = this.props;
    //计算位移
    for (let i = 0; i < tabs.length; i++) {
      const element = tabs[i];
      this.widthArr.push(element.Name.length * fontSize + padding * 2);
    }
    for (let i = 0; i < this.widthArr.length; i++) {
      const ele = this.widthArr[i];
      let arr = this.widthArr.slice(0, i + 1);
      let translate = arr.reduce((prev, cur) => prev + cur);
      this.translateArr.push(translate - ele / 2 - lineW / 2);
    }
    this.onTabChange(defaultActiveKey, false);
  }
  componentWillReceiveProps(nextProps) {
    if (!shallowequal(this.props.defaultActiveKey, nextProps.defaultActiveKey)) {
      this.onTabChange(nextProps.defaultActiveKey, false);
    }
  }
  onTabChange(activeKey, isClick) {
    //isclick判断是否是用户点击事件
    let line = ReactDOM.findDOMNode(this.refs.line);
    line.style.transform = `translateX(${this.translateArr[activeKey]}px)`;
    line.style.WebkitTransform = `translateX(${this.translateArr[activeKey]}px)`;

    if (isClick) {
      typeof this.props.onTabsChange === "function" && this.props.onTabsChange(activeKey);
    }
  }

  openModalExplain() {
    this.setState({
      explainModel: true
    })
  }
  handleCancel(){
    this.setState({
      explainModel: false
    })
  }
  render() {
    const { tabs, defaultActiveKey, isShowExplain } = this.props;
    let { explainModel } = this.state;
    return (
      <div className="center-tabs">
        <div className="center-tabs-links">
          {
            tabs.map((item, key) => (
              <div key={key}
                onClick={this.onTabChange.bind(this, key, true)}
                className={`center-tabs-link ${defaultActiveKey === key ? 'center-tabs-active-link' : ''}`}
                style={{ fontSize, paddingLeft: padding, paddingRight: padding }}
              >
                <span>{item.Name}</span>
              </div>
            ))
          }
          {isShowExplain && <div className='coupon_explain' onClick={this.openModalExplain.bind(this)}>优惠券使用说明</div>}
        </div>
        <div className="center-tabs-animation-line" ref="line" style={{ width: lineW }} />
        <Modal
          title="优惠券使用说明"
          visible={explainModel}
          onCancel={this.handleCancel.bind(this)}
          footer={[]}
          wrapClassName="explain_modal_global"
          bodyStyle={{ color: '#333', lineHeight: 1 }}
        >
          <CouponExplain />
        </Modal>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/features/center/Tabs.js